import { SystemStyleObject } from '@chakra-ui/react';

export const styles: Record<string, SystemStyleObject> = {
	container: {
		boxShadow: 'none',
		borderRadius: 0,
		position: 'relative',
	},
	header: {
		p: 0,
		w: '100%',
		minH: '80px',
		backgroundColor: 'red',
		position: 'fixed',
	},
	body: {
		p: 0,
	},
	footer: {
		p: 0,
		w: '100%',
		minH: '35px',
	},
};
